import React, { useEffect } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton,
} from "@mui/material";
import Typography from "../typography/typography";
import "../filter/filter.scss"; 
import Button from "../button/button";
import { Close } from "@mui/icons-material";

interface FileConfirmationDialogProps {
  open: boolean;
  onClose: () => void;
  onReplace: () => void;
  onKeepBoth: () => void;
  title?: string;
}

const FileConfirmationDialog: React.FC<FileConfirmationDialogProps> = ({
  open,
  onClose,
  onReplace,
  onKeepBoth,
  title
}) => {

  useEffect(() => {
  }, [open])

  return (
    <Dialog open={open} className="filter-container" onClose={onClose}>
      <DialogTitle className="filter-header" sx={{padding: "20px"}}> <Typography type="s3" weight="medium" color="theme.secondary.1000">
        Confirmation
      </Typography>
      <IconButton size="small" onClick={onClose}>
              <Close fontSize="small" />
            </IconButton>
      </DialogTitle>
      <DialogContent sx={{marginTop: "20px"}}>
        <Typography type="s3" weight="medium" color="theme.secondary.1000">
          The destination already has a file named "{title}"
        </Typography>
      </DialogContent>
      <DialogActions className="filter-footer">
        <Button className="cancel-filter-btn" onClick={onKeepBoth} >
          Keep Both
        </Button>
        <Button onClick={onReplace} >
          Replace
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default FileConfirmationDialog;
